import React from 'react';
import Html from '../assets/images/html.png';
import Css from '../assets/images/css.png';
import Javascript from '../assets/images/javascript.png';
import ReactIcon from '../assets/images/react.png';
import Tailwind from '../assets/images/tailwind.png';
import MaterialUI from '../assets/images/materialui.png';
import MongoDB from '../assets/images/mongo.png';
import Next from '../assets/images/next.png';

const Skills = () => {
  return (
    <div
      name="skills"
      className="bg-[#0a192f]   sm:h-full md:h-screen w-full text-gray-300"
    >
      {/* Container */}
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full ">
        <div className="text-center pb-8 pt-20 pl-4 pr-1 w-full ">
          <p className="text-4xl text-gray-300  font-bold inline border-b-4 border-blue-600">
            Skills
          </p>
          <p className="py-4 ">These are the technologies I've worked with</p>
        </div>

        <div className="w-full grid grid-cols-2  lg:grid-cols-4 gap-8 text-center py-8">
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={Html} alt="html logo" />
            <p className="my-4">HTML</p>
          </div>

          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={Css} alt="Css logo" />
            <p className="my-4">Css</p>
          </div>

          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img
              className="w-20 mx-auto"
              src={Javascript}
              alt="Javascript logo"
            />
            <p className="my-4">Javascript</p>
          </div>

          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={ReactIcon} alt="React logo" />
            <p className="my-4">React</p>
          </div>

          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={Tailwind} alt="Tailwind logo" />
            <p className="my-4">Tailwind</p>
          </div>

          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img
              className="w-20 mx-auto"
              src={MaterialUI}
              alt="MaterialUI logo"
            />
            <p className="my-4">MaterialUI</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={MongoDB} alt="MongoDB logo" />
            <p className="my-4">MongoDB</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={Next} alt="Next logo" />
            <p className="my-4">Next</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
